import React, { useEffect } from "react";
import "./AboutMe.css";
import myimage from "../../assets/images/my-image.png";

const AboutMe = () => {
  return (
    <div id="aboutMe" className="w-full bg-emerald-200 bg-opacity-25">
      <div className="container mx-auto py-16 md:py-20 lg:py-36">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-5 md:px-3 lg:px-0 items-center">
          <div className="text-center px-12 pb-5 md:pb-0 hover14">
            <figure className="mx-auto rounded-full bg-white shadow-md w-fit">
              <img
                className="mx-auto rounded-full border border-[#207561]"
                src={myimage}
                alt=""
              />
            </figure>
          </div>
          <div className="pr-0 sm:pr-3">
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-center font-normal md:text-left mb-5 text-[#207561]">
              About Me
            </h2>
            <p className="text-justify text-base lg:text-lg font-light mb-8 sm:mb-6 md:mb-3 lg:mb-0">
              I am a web developer with a strong interest in software
              engineering and technology. I spend most of my free time coding,
              testing out new technologies and writing code. In addition to
              that, I have experience in working with team as I was an IT
              personnel for two reputed organization for three years. In
              addition, I am very interested in developing web apps and having
              projects using Git.
            </p>
            <div className="w-full mt-4 lg:mt-6 text-center md:text-left">
              <a href="#" className="btn bg-[#207561] border-0 font-normal">
                Download Resume
              </a>
              {/* <a
                href="https://drive.google.com/u/1/uc?id=17MjhVx9J7SDLjCrQrlMxnxyJVgqOs6BK&export=download"
                className="btn bg-[#207561] border-0 font-normal"
              >
                Download Resume
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
